import * as _ from 'lodash';

export function showVpcInfo(item:any) {
    let info = item.VpcName;
    if (item.Ipv6CidrBlockAssociationSet) {
        info += `(${item.CidrBlock}, ${_.get(item, 'Ipv6CidrBlockAssociationSet[0].Ipv6CidrBlock')})`;
    } else {
        info += `(${item.CidrBlock})`
    }
    return info
}
